document.addEventListener('click', function (event) {
  const button = event.target.closest('#load-more');
  if (!button) return;

  const nextUrl = button.getAttribute('data-next-url');
  if (!nextUrl) return;

  fetch(nextUrl)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProducts = doc.querySelectorAll('#product-grid > *');
      const productGrid = document.getElementById('product-grid');

      newProducts.forEach(item => productGrid.appendChild(item));

      const newButton = doc.getElementById('load-more');
      if (newButton) {
        button.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
      } else {
        button.remove();
      }
    });
});
